import { apimCall } from './../helpers/api';
import { getGuid, getGuidsFromServer, getPathInfoFromLocation } from './../helpers/utility';
import { getDefaultConfigValue } from './available_steps';
import { SavingWorkflowError } from '../helpers/jargon';
import { showBanner, showMessage } from '../helpers/MessageUtility';
import { GetAppSettings, GoFormzServices } from '../AppSettings';
import { getAppMetadata } from './StepMetadata';
import { RootState } from '../gf-types';
import { Action, StepsMetadata, Trigger, WorkflowStep } from './workflow-types';
import { NavigateFunction } from 'react-router-dom';

export const WORKFLOW_EDITOR_INIT = 'WORKFLOW_EDITOR_INIT';
export const WORKFLOW_EDITOR_INIT_CREATE = 'WORKFLOW_EDITOR_INIT_CREATE';
export const WORKFLOW_EDITOR_INIT_CREATE_WITHWORKFLOW = 'WORKFLOW_EDITOR_INIT_CREATE_WITHWORKFLOW';

export const WORKFLOW_EDITOR_ADD_TRIGGER = 'WORKFLOW_EDITOR_ADD_TRIGGER';
export const WORKFLOW_EDITOR_ADD_STEP = 'WORKFLOW_EDITOR_ADD_STEP';

export const WORKFLOW_EDITOR_STEP_ADD_PROPERTY = 'WORKFLOW_EDITOR_STEP_ADD_PROPERTY';
export const WORKFLOW_EDITOR_SELECT_STEP = 'WORKFLOW_EDITOR_SELECT_STEP';
export const WORKFLOW_EDITOR_CLONE_STEP = 'WORKFLOW_EDITOR_CLONE_STEP';
export const WORKFLOW_EDITOR_DELETE_STEP = 'WORKFLOW_EDITOR_DELETE_STEP';
export const WORKFLOW_EDITOR_STEP_MOVE_UP = 'WORKFLOW_EDITOR_STEP_MOVE_UP';
export const WORKFLOW_EDITOR_STEP_MOVE_DOWN = 'WORKFLOW_EDITOR_STEP_MOVE_DOWN';
export const WORKFLOW_EDITOR_STEP_MOVE = 'WORKFLOW_EDITOR_STEP_MOVE';
export const WORKFLOW_EDITOR_SELECT_TRIGGER = 'WORKFLOW_EDITOR_SELECT_TRIGGER';
export const WORKFLOW_EDITOR_STEP_UPDATE_ID = 'WORKFLOW_EDITOR_STEP_UPDATE_ID';
export const WORKFLOW_EDITOR_STEP_UPDATE_PROPERTY = 'WORKFLOW_EDITOR_STEP_UPDATE_PROPERTY';
export const WORKFLOW_EDITOR_STEP_UPDATE_PROPERTY_NAME = 'WORKFLOW_EDITOR_STEP_UPDATE_PROPERTY_NAME';
export const WORKFLOW_EDITOR_STEP_REMOVE_PROPERTY = 'WORKFLOW_EDITOR_STEP_REMOVE_PROPERTY';
export const WORKFLOW_EDITOR_UPDATE_NAME = 'WORKFLOW_EDITOR_UPDATE_NAME';
export const WORKFLOW_EDITOR_UPDATE_ACTIVE = 'WORKFLOW_EDITOR_UPDATE_ACTIVE';
export const WORKFLOW_EDITOR_MAKE_CHANGES = 'WORKFLOW_EDITOR_MAKE_CHANGES';

export const WORKFLOW_GET_REQUEST = 'WORKFLOW_GET_REQUEST';
export const WORKFLOW_GET_SUCCESS = 'WORKFLOW_GET_SUCCESS';
export const WORKFLOW_GET_FAILURE = 'WORKFLOW_GET_FAILURE';

export const WORKFLOW_UPDATE_REQUEST = 'WORKFLOW_UPDATE_REQUEST';
export const WORKFLOW_UPDATE_SUCCESS = 'WORKFLOW_UPDATE_SUCCESS';
export const WORKFLOW_UPDATE_FAILURE = 'WORKFLOW_UPDATE_FAILURE';

export const WORKFLOW_TEMPLATES_GET_REQUEST = 'WORKFLOW_TEMPLATES_GET_REQUEST';
export const WORKFLOW_TEMPLATES_GET_SUCCESS = 'WORKFLOW_TEMPLATES_GET_SUCCESS';
export const WORKFLOW_TEMPLATES_GET_FAILURE = 'WORKFLOW_TEMPLATES_GET_FAILURE';

export const WORKFLOW_TEMPLATE_FOLDERS_GET_REQUEST = 'WORKFLOW_TEMPLATE_FOLDERS_GET_REQUEST';
export const WORKFLOW_TEMPLATE_FOLDERS_GET_SUCCESS = 'WORKFLOW_TEMPLATE_FOLDERS_GET_SUCCESS';
export const WORKFLOW_TEMPLATE_FOLDERS_GET_FAILURE = 'WORKFLOW_TEMPLATE_FOLDERS_GET_FAILURE';

export const WORKFLOW_PUBLISHEDAPPS_SUCCESS = 'WORKFLOW_PUBLISHEDAPPS_SUCCESS';

export const WORKFLOW_EDITOR_METADATA_UPDATE_INPUTCONFIG = 'WORKFLOW_EDITOR_METADATA_UPDATE_INPUTCONFIG';
export const WORKFLOW_EDITOR_METADATA_UPDATE_STEP_METADATA = 'WORKFLOW_EDITOR_METADATA_UPDATE_STEP_METADATA';
export const WORKFLOW_EDITOR_UPDATE_OBJECTLIST = 'WORKFLOW_EDITOR_UPDATE_OBJECTLIST';
export const WORKFLOW_EDITOR_NEXT_STEP = 'WORKFLOW_EDITOR_NEXT_STEP';

export const ensureMetadataIsLoaded = () => async (dispatch, getState: () => RootState) => {
  const state: RootState = getState();
  const publishedAppsLoaded = state.workfloweditor.publishedAppsLoaded;

  if (!publishedAppsLoaded) {
    const publishedAppResponse = await apimCall(GoFormzServices.ApplicationService, '/publishedapps?onlyActive=true');
    dispatch({
      type: WORKFLOW_PUBLISHEDAPPS_SUCCESS,
      payload: {
        publishedApps: publishedAppResponse.data.data.items,
        publishedAppsLoaded: true
      }
    });
  }
};

export const getWorkflowTemplates = () => (dispatch) => {
  dispatch({
    type: WORKFLOW_TEMPLATES_GET_REQUEST,
    payload: {
      initialized: true,
      isFetching: true,
      items: null,
      count: 0
    }
  });

  return apimCall(GoFormzServices.TemplateService, '/templates?take=10000').then((response) =>
    dispatch({
      type: WORKFLOW_TEMPLATES_GET_SUCCESS,
      payload: {
        count: response.data.items.length,
        totalCount: response.data.totalCount,
        isFetching: false,
        items: response.data.items
      }
    })
  );
};

export const getWorkflowTemplateFolders = () => async (dispatch) => {
  dispatch({
    type: WORKFLOW_TEMPLATE_FOLDERS_GET_REQUEST,
    payload: {
      initialized: true,
      isFetching: true,
      items: null
    }
  });

  const response = await apimCall(GoFormzServices.TemplateService, '/folders');
  dispatch({
    type: WORKFLOW_TEMPLATE_FOLDERS_GET_SUCCESS,
    payload: {
      isFetching: false,
      items: response.data
    }
  });
};

export const workflowEditorSelectTrigger = () => (dispatch, getState: () => RootState) => {
  const state: RootState = getState();
  const triggerType = state.workfloweditor.workflow?.trigger?.type;
  const templateRequestInitialized = state.workfloweditor.templates?.initialized;
  if (!templateRequestInitialized && triggerType === 'GoFormzEvent') {
    getWorkflowTemplates()(dispatch);
    getWorkflowTemplateFolders()(dispatch);
  }

  dispatch({
    type: WORKFLOW_EDITOR_SELECT_TRIGGER,
    payload: {
      selectedTrigger: true,
      selectedStepId: null
    }
  });
};

export const workflowEditorSelectStep = (stepId: string) => (dispatch) => {
  dispatch({
    type: WORKFLOW_EDITOR_SELECT_STEP,
    payload: {
      selectedStepId: stepId,
      selectedTrigger: false
    }
  });
};

export const workflowEditorSetNextStep = (stepId: string) => (dispatch) => {
  dispatch({
    type: WORKFLOW_EDITOR_NEXT_STEP,
    payload: {
      nextStepId: stepId
    }
  });
};

export const workflowEditorCloneStep = (stepId: string) => ({
  type: WORKFLOW_EDITOR_CLONE_STEP,
  payload: {
    stepId
  }
});

export const workflowEditorDeleteStep = (stepId: string) => ({
  type: WORKFLOW_EDITOR_DELETE_STEP,
  payload: {
    stepId
  }
});

export const workflowEditorStepMoveUp = (stepId: string) => ({
  type: WORKFLOW_EDITOR_STEP_MOVE_UP,
  payload: {
    stepId
  }
});

export const workflowEditorStepMoveDown = (stepId: string) => ({
  type: WORKFLOW_EDITOR_STEP_MOVE_DOWN,
  payload: {
    stepId
  }
});

export const workflowEditorStepMove = (stepId: string, stepPosition: number) => ({
  type: WORKFLOW_EDITOR_STEP_MOVE,
  payload: {
    stepId,
    stepPosition
  }
});

export const workflowEditorMetadataUpdateStepMetadata = (step: WorkflowStep) => async (dispatch) => {
  const metadataInput = {};
  const config = step.config;

  for (const configKey of Object.keys(config)) {
    if (configKey.indexOf('appinput_') === 0) {
      metadataInput[configKey.substring(9)] = step.config[configKey];
    }
  }

  const appMetadata = getAppMetadata(config.appId);
  if (!appMetadata.globalInstall && !step.config.appInstanceId) {
    // no connection, so skip
    return;
  }

  const response = await apimCall(
    GoFormzServices.AppsApimService,
    `/apps/${appMetadata.appPath}/metadata`,
    'POST',
    {
      type: 'command',
      name: step.config.appCommand,
      input: metadataInput
    },
    null,
    {
      'X-AppInstance-Id': step.config.appInstanceId
    }
  );
  dispatch({
    type: WORKFLOW_EDITOR_METADATA_UPDATE_STEP_METADATA,
    payload: {
      stepId: step.id,
      dynamicMetadata: response.data
    }
  });
};

export const workflowEditorAddTrigger = (availableAction: Trigger) => (dispatch) => {
  const trigger: Trigger = getDefaultConfigValue(availableAction);
  if (availableAction.id === 'Schedule') {
    trigger.environment = GetAppSettings().Environment;
  }
  dispatch({
    type: WORKFLOW_EDITOR_ADD_TRIGGER,
    payload: {
      trigger
    }
  });
  dispatch(workflowEditorSelectTrigger());
};

export const workflowEditorAddStep = (id: string, action: Action, stepPosition?: number) => (dispatch) => {
  const step: WorkflowStep = {
    id,
    action: {
      adapterName: action.adapterName
    },
    config: getDefaultConfigValue(action)
  };
  dispatch({
    type: WORKFLOW_EDITOR_ADD_STEP,
    payload: {
      step,
      stepPosition
    }
  });
  dispatch(workflowEditorSelectStep(id));

  workflowEditorMetadataUpdateStepMetadata(step)(dispatch);
};

export const workflowEditorUpdateStepId = (currentStepId: string, newStepId: string) => ({
  type: WORKFLOW_EDITOR_STEP_UPDATE_ID,
  payload: {
    currentStepId,
    newStepId
  }
});

export const workflowEditorUpdateStepProperty = (propKeyPath: string[], propValue: string) => ({
  type: WORKFLOW_EDITOR_STEP_UPDATE_PROPERTY,
  payload: {
    propKeyPath,
    propValue
  }
});

export const workflowEditorUpdateStepPropertyName = (propKeyPath: string[], oldName: string, newName: string) => ({
  type: WORKFLOW_EDITOR_STEP_UPDATE_PROPERTY_NAME,
  payload: {
    propKeyPath,
    oldName,
    newName
  }
});

export const workflowEditorStepRemoveProperty = (propKeyPath: string[], name: string) => ({
  type: WORKFLOW_EDITOR_STEP_REMOVE_PROPERTY,
  payload: {
    propKeyPath,
    name
  }
});

export const workflowEditorStepAddProperty = (propKeyPath: string[], value: string) => ({
  type: WORKFLOW_EDITOR_STEP_ADD_PROPERTY,
  payload: {
    propKeyPath,
    value
  }
});

export const workflowEditorUpdateName = (name: string) => ({
  type: WORKFLOW_EDITOR_UPDATE_NAME,
  payload: {
    name
  }
});

export const workflowEditorUpdateActive = (active: boolean) => ({
  type: WORKFLOW_EDITOR_UPDATE_ACTIVE,
  payload: {
    active
  }
});

export const getWorkflowRequest = () => ({
  type: WORKFLOW_GET_REQUEST,
  payload: {
    isFetching: true,
    error: ''
  }
});

export const getWorkflowSuccess = (data) => ({
  type: WORKFLOW_GET_SUCCESS,
  payload: {
    error: '',
    isFetching: false,
    workflow: data.workflow,
    metadata: data.metadata,
    versionNumber: data.versionNumber
  }
});

export const getWorkflowFailure = (errorResponse) => ({
  type: WORKFLOW_GET_FAILURE,
  payload: {
    error: { statusCode: errorResponse.status },
    isFetching: false
  }
});

export const updateWorkflowRequest = (workflowId?) => ({
  type: WORKFLOW_UPDATE_REQUEST,
  payload: {
    isSaving: true,
    workflowId,
    isFetching: false,
    error: ''
  }
});

export const updateWorkflowSuccess = () => ({
  type: WORKFLOW_UPDATE_SUCCESS,
  payload: {
    isSaving: false,
    isDirty: false,
    lastSaveDate: new Date()
  }
});

export const updateWorkflowFailure = (error) => ({
  type: WORKFLOW_UPDATE_FAILURE,
  payload: {
    isSaving: false,
    error: handleError(error, SavingWorkflowError),
    isFetching: false
  }
});

export const updateObjectList = (stepsMetadata: StepsMetadata) => ({
  type: WORKFLOW_EDITOR_UPDATE_OBJECTLIST,
  payload: { stepsMetadata }
});

export const workflowEditorNextStep = () => (dispatch, getState: () => RootState) => {
  const state: RootState = getState();
  const nextStepId = state.workfloweditor.nextStepId;
  if (nextStepId) {
    dispatch(workflowEditorSelectStep(nextStepId));
  }
};

export const workflowEditorMetadataUpdateInputConfig = (stepId, key, configName, configValue) => ({
  type: WORKFLOW_EDITOR_METADATA_UPDATE_INPUTCONFIG,
  payload: {
    stepId,
    key,
    configName,
    configValue
  }
});

export const getWorkflow = (workflowId) => async (dispatch) => {
  dispatch(getWorkflowRequest());
  try {
    const response = await apimCall(GoFormzServices.WorkflowService, `/workflows/${workflowId}/metadata`);
    dispatch(getWorkflowSuccess(response.data));
  } catch (err) {
    dispatch(getWorkflowFailure(err.response));
  }
};

export const getWorkflowVersion = (workflowId, versionId) => async (dispatch) => {
  dispatch(getWorkflowRequest());
  try {
    const response = await apimCall(GoFormzServices.WorkflowService, `/workflows/${workflowId}/versions/${versionId}`);
    dispatch(getWorkflowSuccess(response.data));
  } catch (err) {
    dispatch(getWorkflowFailure(err.response));
  }
};

export const removeBlankObjectsFromWorkflowStepMetadata = (stepsMetadata: StepsMetadata) => async (dispatch) => {
  dispatch(updateObjectList(stepsMetadata));
};

export const updateWorkflow = (data, navigate: NavigateFunction, step: string, publish?: boolean) => async (dispatch, getState: () => RootState) => {
  const state: RootState = getState();
  const workflow = { ...state.workfloweditor.workflow };
  const workflowMetadata = state.workfloweditor.metadata;
  const create = state.workfloweditor.create;
  let redirectAfterSave = true;

  if (!workflow.id) {
    await getGuidsFromServer(10000);
    workflow.id = getGuid();
  }

  let workflowJson = data;
  if (!data) {
    workflowJson = workflow;
    redirectAfterSave = false;
  }

  dispatch(updateWorkflowRequest());

  return await apimCall(GoFormzServices.WorkflowService, `workflows/${workflow.id}`, 'PUT', {
    workflow: workflowJson,
    metadata: workflowMetadata ? workflowMetadata : null,
    publish: !!publish
  })
    .then(() => dispatch(updateWorkflowSuccess()))
    .then(() => {
      !publish && showBanner('Workflow saved');

      // ensure the navigate happens after everything else is rendered
      // an edge case caused this to sometimes not work correctly
      setTimeout(() => {
        if (redirectAfterSave) {
          navigate('/workflow');
        } else if (create) {
          const path = `/workflows/${workflow.id}${step ? `?step=${step}` : ''}`;
          navigate(path);
        }
      }, 0);
    })
    .catch((error) => {
      const message = error?.response?.data?.message || SavingWorkflowError;
      showMessage('Error', `${handleError(error, message)}`);
      dispatch(updateWorkflowFailure(error));
    });
};

export const initWorkflowEditor = (workflowId, initialWorkflow, versionId) => (dispatch, getState: () => RootState) => {
  const pathInfo = getPathInfoFromLocation();
  const params = pathInfo.params;

  if (initialWorkflow) {
    dispatch({
      type: WORKFLOW_EDITOR_INIT_CREATE_WITHWORKFLOW,
      payload: {
        initialWorkflow
      }
    });
    if (initialWorkflow.trigger) {
      dispatch(workflowEditorSelectTrigger());
    }
  } else if (pathInfo.pathname.startsWith('/workflows/create')) {
    dispatch({
      type: WORKFLOW_EDITOR_INIT_CREATE,
      payload: {
        initialWorkflow
      }
    });
  } else {
    dispatch({
      type: WORKFLOW_EDITOR_INIT,
      payload: {
        wizardMode: Boolean(params.wizard),
        environment: GetAppSettings().Environment
      }
    });

    let result = null;
    if (versionId) {
      result = getWorkflowVersion(workflowId, versionId)(dispatch);
    } else {
      result = getWorkflow(workflowId)(dispatch);
    }
    result.then(() => {
      if (params.wizard) {
        // select the trigger by default in wizard mode
        dispatch(workflowEditorSelectTrigger());
      }
    });
  }

  ensureMetadataIsLoaded()(dispatch, getState);
};

function handleError(error, defaultMessage) {
  if (error.status === '400') {
    const jsonResponse = JSON.parse(error.responseText);
    if (jsonResponse) return jsonResponse.error;
  }

  return defaultMessage;
}
